import { render, staticRenderFns } from "./PromotionGroup.vue?vue&type=template&id=da01729c&"
import script from "./PromotionGroup.vue?vue&type=script&lang=ts&"
export * from "./PromotionGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports